import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import VueSvgColor from '../assets/vue.svg';

export const VueColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-vue" className={cx('sdkIcon', className)} size={size} {...props}>
    <VueSvgColor />
  </LegacyIcon>
);
